module.exports = __webpack_public_path__ + "img/hey.bdc06576.gif";